import { Outlet, Link, useLocation } from 'react-router-dom'
import { APP_CONFIG } from '../types'
import './AdminLayout.css'

export default function AdminLayout() {
    const location = useLocation()

    const navItems = [
        { path: '/admin', label: 'Dashboard', icon: '📊', exact: true },
        { path: '/admin/inventory', label: 'Inventory', icon: '📦' },
        { path: '/admin/pos', label: 'POS', icon: '🛒' },
        { path: '/admin/orders', label: 'Orders', icon: '📋' },
        { path: '/admin/ai-studio', label: 'AI Studio', icon: '✨' }
    ]

    const isActive = (path: string, exact = false) => {
        if (exact) return location.pathname === path
        return location.pathname.startsWith(path)
    }

    return (
        <div className="admin-layout">
            {/* Sidebar */}
            <aside className="admin-sidebar">
                <div className="admin-sidebar-header">
                    <Link to="/" className="admin-logo">
                        <span className="logo-icon">👗</span>
                        <div className="logo-text">
                            <span className="logo-name">{APP_CONFIG.STORE_NAME}</span>
                            <span className="logo-tagline">Admin Panel</span>
                        </div>
                    </Link>
                </div>

                <nav className="admin-nav">
                    {navItems.map(item => (
                        <Link
                            key={item.path}
                            to={item.path}
                            className={`admin-nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}
                        >
                            <span className="admin-nav-icon">{item.icon}</span>
                            <span>{item.label}</span>
                        </Link>
                    ))}
                </nav>

                <div className="admin-sidebar-footer">
                    <Link to="/" className="admin-back-link">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M19 12H5M12 19l-7-7 7-7" />
                        </svg>
                        <span>Back to Store</span>
                    </Link>
                </div>
            </aside>

            {/* Main Content */}
            <main className="admin-main">
                <div className="admin-content">
                    <Outlet />
                </div>
            </main>

            {/* Mobile Header */}
            <header className="admin-mobile-header">
                <Link to="/" className="admin-logo-mobile">
                    <span className="logo-icon">👗</span>
                    <span className="logo-name">{APP_CONFIG.STORE_NAME}</span>
                </Link>
            </header>

            {/* Mobile Navigation */}
            <nav className="admin-mobile-nav">
                {navItems.map(item => (
                    <Link
                        key={item.path}
                        to={item.path}
                        className={`admin-mobile-nav-item ${isActive(item.path, item.exact) ? 'active' : ''}`}
                    >
                        <span className="admin-nav-icon">{item.icon}</span>
                        <span>{item.label}</span>
                    </Link>
                ))}
            </nav>
        </div>
    )
}
